// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PKqd","title":"styles_title__2L5yJ"};